import React, { useState } from "react";
import ReportsTabs from "../common-elements/ReportsTabs";
import SearchFilter from "./elements/searchFilter";
import StaticTableContent from "./elements/StaticTableContent";
import TopPage from "./elements/toppage";

const LFD = () => {
  
  return (
    <React.Fragment>
      <div className="position-relative subheader-wrapper">
        <ReportsTabs activeTab={6} />
        <div className="page-fluid">
          
          <SearchFilter />
          <StaticTableContent />
        </div>
      </div>
    </React.Fragment>
  );
};

export default LFD;
